<template>
  <div style="width: 100%">
    <v-row>
    <v-menu v-model="showMenu" style="width: 100%; z-index:1001;" :close-on-content-click="false" :disabled="disabled">
      <template v-slot:activator="{ on }">
      <v-col
        :style="`padding:1px; height: 44px; width: 100%; background-color: ${backgroundColor}; border: 1px solid rgba(0, 0, 0, 0.5); border-radius: 4px; overflow: hidden;`"
        v-on="on"
        >
        <v-chip
          v-if="getQuery.or"
          :class="` red ${tagTheme} my-1 `"
          close
          :disabled="disabled"
          @input="searchOr(false)"
          @click:close="searchOr(false)"
          >Or: {{ getQuery.or }}
        </v-chip>
        <template v-if="getQuery.categoriesEmpty">
              <v-chip
              @input="searchCategoryEmptyToggle"
              dark
              class="blue darken-3 my-1"
              close
              @click:close="searchCategoryEmptyToggle"
              >Category: NULL</v-chip>
            </template>
            <template v-else v-for="(cat, i) in getQuery.categories">
              <v-chip
              :key="i + 1000"
              :class="` blue ${tagTheme} my-1 `"
              close
              @click:close="searchClearCateogry(i)"
              @input="searchClearCateogry(i)"
              >Category: {{ getCategoryName(cat.id) }}</v-chip>
            </template>
            <template v-if="getQuery.tagsEmpty">
              <v-chip
              @input="searchTagEmptyToggle"
              dark
              class="green darken-3 my-1"
              close
              @click:close="searchTagEmptyToggle"
              >Tag: NULL</v-chip>
            </template>
            <template v-else v-for="(tag, i) in getQuery.tags">
              <v-chip
              :class="` green ${tagTheme} my-1 `"
              :key="i + 2000"
              close
              @click:close="searchClearTag(i)"
              @input="searchClearTag(i)"
              >Tag: {{ tag }}</v-chip>
            </template>
            <template v-if="getQuery.uploader">
              <v-chip
              :class="` pink ${tagTheme} my-1 `"
              close
              @click:close="searchClearUploader()"
              >Uploader: {{ selectorUsername }}</v-chip>
            </template>
            <template v-if="getQuery.search">
              <v-chip
              :class="` yellow darken-1 ${tagTheme} my-1 `"
              close
              @click:close="searchClearPartial()"
              >Search: {{ getQuery.search }}</v-chip>
            </template>
            <template v-if="getQuery.search && getQuery.searchPartialText">
              <v-chip
              :class="` yellow darken-1 ${tagTheme} my-1 `"
              close
              @click:close="togglePartial()"
              >Partial: true</v-chip>
            </template>
        <v-chip
          v-if="getQuery.dateStart"
          :class="` yellow ${tagTheme} my-1 `"
          close
          :disabled="disabled"
          @input="() => selector.dateStart = null"
          @click:close="() => selector.dateStart = null"
          >Start: {{ formatDate(getQuery.dateStart) }}
        </v-chip>
        <v-chip
          v-if="getQuery.dateEnd"
          :class="` orange ${tagTheme} my-1 `"
          close
          :disabled="disabled"
          @input="() => selector.dateEnd = null"
          @click:close="() => selector.dateEnd = null"
          >End: {{ formatDate(getQuery.dateEnd) }}
        </v-chip>
        <v-spacer></v-spacer>
      </v-col>
      </template>
      <v-card>
        <v-card-text style="padding-bottom: 0px;">
          <div
            :style="`padding:0px; min-height: 0px; width: 100%; background-color: ${backgroundColor}; border: 0px solid rgba(0, 0, 0, 0.5); border-radius: 4px;`"
            >
            <v-chip
              v-if="getQuery.or"
              :class="` red ${tagTheme} my-1 `"
              close
              @input="searchOr(false)"
              @click:close="searchOr(false)"
              >Or: {{ getQuery.or }}
            </v-chip>
            <template v-if="getQuery.categoriesEmpty">
              <v-chip
              @input="searchCategoryEmptyToggle"
              dark
              class="blue darken-3 my-1"
              close
              @click:close="searchCategoryEmptyToggle"
              >Category: NULL</v-chip>
            </template>
            <template v-else v-for="(cat, i) in getQuery.categories">
              <v-chip
              :key="i + 1000"
              :class="` blue ${tagTheme} my-1 `"
              close
              @input="searchClearCateogry(i)"
              @click:close="searchClearCateogry(i)"
              >Category: {{ getCategoryName(cat.id) }}</v-chip>
            </template>
            <template v-if="getQuery.tagsEmpty">
              <v-chip
              @input="searchTagEmptyToggle"
              dark
              class="green darken-3 my-1"
              close
              @click:close="searchTagEmptyToggle"
              >Tag: NULL</v-chip>
            </template>
            <template v-else v-for="(tag, i) in getQuery.tags">
              <v-chip
              :class="` green ${tagTheme} my-1 `"
              :key="i + 2000"
              close
              @input="searchClearTag(i)"
              @click:close="searchClearTag(i)"
              >Tag: {{ tag }}</v-chip>
            </template>
            <template v-if="getQuery.uploader">
              <v-chip
              :class="` pink ${tagTheme} my-1 `"
              close
              @click:close="searchClearUploader()"
              >Uploader: {{ selectorUsername }}</v-chip>
            </template>
            <template v-if="getQuery.search">
              <v-chip
              :class="` yellow darken-1 ${tagTheme} my-1 `"
              close
              @click:close="searchClearPartial()"
              >Search: {{ getQuery.search }}</v-chip>
            </template>
            <template v-if="getQuery.search && getQuery.searchPartialText">
              <v-chip
              :class="` yellow darken-1 ${tagTheme} my-1 `"
              close
              @click:close="togglePartial()"
              >Partial: true</v-chip>
            </template>
            <v-chip
              v-if="getQuery.dateStart"
              :class="` yellow ${tagTheme} my-1 `"
              close
              @input="() => selector.dateStart = null"
              @click:close="() => selector.dateStart = null"
              >Start: {{ formatDate(getQuery.dateStart) }}
            </v-chip>
            <v-chip
              v-if="getQuery.dateEnd"
              :class="` orange ${tagTheme} my-1 `"
              close
              @input="() => selector.dateEnd = null"
              @click:close="() => selector.dateEnd = null"
              >End: {{ formatDate(getQuery.dateEnd) }}
            </v-chip>
          </div>
            <v-combobox
            prepend-icon="label"
            label="Tags"
            v-model="selectorTag"
            @change="() => addTag(selectorTag)"
            :items="avaiableTags"
            item-text="name"
            hide-details
            no-data-text="No available tags"
            :readonly="getQuery.tagsEmpty"
            style="width:100%;"
            >
              <template v-slot:append-outer>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-icon
                    v-on="on"
                    @click="searchTagEmptyToggle"
                    :class="[{ 'red--text': getQuery.tagsEmpty }]"
                    >block</v-icon>
                  </template>
                  <span>Search Images w/o Tags</span>
                </v-tooltip>
              </template>
            </v-combobox>
            <v-autocomplete
            auto-select-first
            prepend-icon="local_offer"
            label="Categories"
            v-model="selectorCategory"
            @change="() => addCategory(selectorCategory)"
            :items="avaiableCategories"
            hide-details
            item-value="id"
            item-text="name"
            no-data-text="No available categories"
            :readonly="getQuery.categoriesEmpty"
            return-object
            >
              <template v-slot:append-outer>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-icon
                    v-on="on"
                    @click="searchCategoryEmptyToggle"
                    :class="[{ 'red--text': getQuery.categoriesEmpty }]"
                    >block</v-icon>
                  </template>
                  <span>Search Images w/o Categories</span>
                </v-tooltip>
              </template>
            </v-autocomplete>
            <v-row wrap style="padding: 0px 12px; margin-top: 1px;">
              <v-text-field
              prepend-icon="search"
              v-model="selector.text"
              append-icon="clear"
              @click:append="(event) => clearTextSearch()"
              label="Search"
              hide-details
              v-on:keyup.enter="() => searchText(selector.text)"
              >
              </v-text-field>

              <v-checkbox
              class="custom-checkbox"
              :value="getQuery.searchPartialText"
              label="Partial"
              @click.stop="togglePartial"
              >
              </v-checkbox>

            </v-row>
            <!-- Uploader Search -->
            <v-autocomplete
            prepend-icon="account_circle"
            label="Uploader"
            v-model="selectorUploader"
            @change="() => addUploader(selectorUploader)"
            :items="avaiableUploader"
            item-text="name"
            hide-details
            no-data-text="No uploaders"
            :readonly="getQuery.uploaderEmpty"
            style="width:100%;"
            >
            </v-autocomplete>
            <v-row wrap>
              <v-col cols="6" md="6" style="padding-right: 8px;">
                <date-time-view
                v-model="selector.dateStart"
                clear
                label="Start Date"
                ></date-time-view>
              </v-col>
              <v-col cols="6" md="6" style="padding-right: 8px;">
                <date-time-view
                clear
                v-model="selector.dateEnd"
                label="End Date"
                ></date-time-view>
              </v-col>
            </v-row>
            <v-row wrap>
              <v-btn color="blue darken-2" class="ma-2" dark @click="setToday()">
                Today
              </v-btn>
              <v-btn color="blue darken-2" class="ma-2" dark @click="setWeek()" >
                7 Days
              </v-btn>
              <v-btn color="blue darken-2" class="ma-2" dark @click="setMonth()" >
                31 days
              </v-btn>
              <v-btn color="blue darken-2" class="ma-2" dark @click="setThisMonth()" >
                Current Month
              </v-btn>
            </v-row>
            <v-checkbox
              :value="getQuery.or"
              label="Or query parameters together"
              @click.stop="toggleOr"
            >
            </v-checkbox>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="localSearchClear()">Clear</v-btn>
            <v-btn text color="blue" @click="showMenu = false">Close</v-btn>
          </v-card-actions>
        </v-card>
    </v-menu>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" @click="searchClear" :disabled="disabled"><v-icon>clear</v-icon></v-btn>
      </template>
      <span>Clear</span>
    </v-tooltip>
    </v-row>
  </div>
</template>

<style scoped>
.custom-checkbox {
margin-top: 16px;
margin-left: 15px;
}
</style>

<script>
import moment from 'moment'
import {mapGetters, mapMutations} from 'vuex'
import DateTimeView from './DateTimeView'

// import ApiRequests from '@/api/ApiRequests'
import {DATEFORMATSTRING} from '@/shared/constants'

export default {
  components: {
    DateTimeView
  },

  props: {
    categories: null,
    disabled: Boolean
  },

  data () {
    return {
      selector: {
        or: false,
        dateEnd: null,
        dateStart: null
      },
      selectorUsername: '',
      usernames: [],
      selectorCategory: {},
      selectorTag: '',
      selectorUploader: '',
      showMenu: false
    }
  },

  computed: {
    ...mapGetters([
      'getCategories',
      'getQuery',
      'getTags',
      'getUploader',
      'isQuery'
    ]),

    tagTheme: function () {
      if (this.$vuetify.theme.isDark) {
        return 'darken-2'
      } else {
        return 'lighten-2'
      }
    },

    avaiableTags: function () {
      return this.getTags.filter(e => !this.getQuery.tags.includes(e))
    },

    avaiableUploader: function () {
      this.usernames = this.getUploader
      let users = []
      for (const i of this.usernames) {
        users.push(i.username.toLowerCase())
      }
      return users
    },

    avaiableCategories: function () {
      return this.getCategories.filter(e => this.getQuery.categories.findIndex(f => f.id === e.id) === -1)
    },

    backgroundColor: function () {
      if (this.disabled) {
        // console.log(this.$vuetify.theme.isDark)
        return 'rgba(0, 0, 0, 0);'
      } else if (this.$vuetify.theme.isDark) {
        return '#535353'
      } else {
        return 'white'
      }
    }
  },

  watch: {
    'selector.dateEnd': function () {
      this.searchDateEnd(this.selector.dateEnd)
    },

    'selector.dateStart': function () {
      this.searchDateStart(this.selector.dateStart)
    }
  },

  methods: {
    ...mapMutations([
      'searchClearCateogry',
      'searchClearTag',
      'searchClearUploader',
      'searchClearPartial',
      'searchCategory',
      'searchCategoryEmptyToggle',
      'searchClear',
      'searchDateEnd',
      'searchDateStart',
      'searchOr',
      'searchTag',
      'searchTagEmptyToggle',
      'searchUploader',
      'searchPartial',
      'searchPartialText'
    ]),

    addCategory: function (value) {
      this.searchCategory(value)
      this.$nextTick(() => {
        this.selectorCategory = {}
      })
    },

    addTag: function (value) {
      this.searchTag(value)
      this.$nextTick(() => {
        this.selectorTag = ''
      })
    },

    addUploader: function (value) {
      this.selectorUsername = value
      this.searchUploader(value)
      for (const i of this.usernames) {
        if (i.username === value.toUpperCase()) {
          this.searchUploader(i.id)
        }
      }
      this.$nextTick(() => {
        this.selectorUploader = ''
      })
    },

    formatDate: function (value) {
      if (value) {
        if (value !== '0001-01-01T00:00:00Z') {
          return moment(value).format(DATEFORMATSTRING + ' hh:mm A')
        }
      }
      return ''
    },

    getCategoryName (id) {
      var list = this.getCategories.filter(e => e.id === id)
      if (list.length > 0) {
        return list[0].name
      }
      return 'N/A'
    },

    localSearchClear: function () {
      this.searchClear()
      this.selector.dateEnd = null
      this.selector.dateStart = null
    },

    clearTextSearch: function () {
      this.selector.text = ''
      this.searchClearPartial()
    },

    searchText: function (text) {
      if (text !== '') {
        this.searchPartial(text)
      }
      this.selector.text = ''
    },

    alert: function (msg) {
      alert(msg)
    },

    toggleOr: function () {
      if (this.getQuery.or) {
        this.searchOr(false)
      } else {
        this.searchOr(true)
      }
    },

    setToday: function () {
      this.selector.dateStart = moment().startOf('day').format()
      this.selector.dateEnd = moment().endOf('day').format()
    },

    setWeek: function () {
      this.selector.dateStart = moment().startOf('day').subtract(6, 'day').format()
      this.selector.dateEnd = moment().endOf('day').format()
    },

    setMonth: function () {
      this.selector.dateStart = moment().startOf('day').subtract(30, 'day').format()
      this.selector.dateEnd = moment().endOf('day').format()
    },

    setThisMonth: function () {
      this.selector.dateStart = moment().startOf('month').format()
      this.selector.dateEnd = moment().endOf('day').format()
    },

    togglePartial: function () {
      if (this.getQuery.searchPartialText) {
        this.searchPartialText(false)
      } else {
        this.searchPartialText(true)
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// SearchBar.vue?65f4aebb